import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/GLB_Oxxo_V4.glb";
import { gsap } from "gsap";

export class MapLocalSubtopicOne extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Gondola = gltf.scene.getObjectByName("Gondola", true);
			this.Gondola001 = gltf.scene.getObjectByName("Gondola001", true);
			this.Gondola002 = gltf.scene.getObjectByName("Gondola002", true);
			this.Mostrador001 = gltf.scene.getObjectByName("Mostrador001", true);
			this.Mostrador = gltf.scene.getObjectByName("Mostrador", true);
			this.Refris001 = gltf.scene.getObjectByName("Refris001", true);
			this.Armario = gltf.scene.getObjectByName("Armario", true);
			this.Puerta = gltf.scene.getObjectByName("Puerta", true);
			this.Piso = gltf.scene.getObjectByName("Piso", true);
			this.Techo = gltf.scene.getObjectByName("Techo", true);
			this.Paredes = gltf.scene.getObjectByName("Paredes", true);
			this.Refri_coca_1 = gltf.scene.getObjectByName("Refri_coca_1", true);
			this.Estructura001 = gltf.scene.getObjectByName("Estructura001", true);
			this.Yelox = gltf.scene.getObjectByName("Yelox", true);
			this.Helado = gltf.scene.getObjectByName("Helado", true);

			// gltf.scene.traverse((node) => {
			// 	if (node.isMesh) {
			// 		const material = node.material;
			// 		material.transparent = true; // Permite la transparencia
			// 		material.opacity = 0.1; // Establece la opacidad (0.5 para 50% de opacidad)
			// 	}
			// });
		});
	}

	createSceneGlobal() {
		const newMaterialPiso = this.Piso.material.clone();
		newMaterialPiso.color.set(0xd6d6d6);
		newMaterialPiso.emissiveIntensity = 2;
		newMaterialPiso.emissive.set("#2E2E2E");
		this.Piso.material = newMaterialPiso;
		const newMaterialTecho = this.Techo.material.clone();
		newMaterialTecho.color.set(0xffffff);
		newMaterialTecho.emissiveIntensity = 2;
		newMaterialTecho.emissive.set("#595959");
		this.Techo.material = newMaterialTecho;
		const newMaterialHelado = this.Helado.material.clone();
		newMaterialHelado.color.set(0xd1d1d1);
		newMaterialHelado.emissiveIntensity = 3.6;
		newMaterialHelado.emissive.set("#5E5E5E");
		this.Helado.material = newMaterialHelado;

		this.Paredes.material.emissiveIntensity = 2;
		this.Refri_coca_1.material.emissiveIntensity = 0.98;
		this.Yelox.material.emissiveIntensity = 2.58;
		this.Estructura001.material.emissive.set("#595959");
		this.Estructura001.material.emissiveIntensity = 1;
		this.Mostrador001.material.emissive.set("#737373");
		this.Mostrador001.material.emissiveIntensity = 2;
	}

	animateEnfasisMostrador() {
		this.animationMostrador = gsap.to(this.Mostrador001.material, {
			emissiveIntensity: 15,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationGondola1 = gsap.to(this.Gondola001.material, {
			emissiveIntensity: 15,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
		this.animationGondola2 = gsap.to(this.Gondola002.material, {
			emissiveIntensity: 15,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}
	stopAnimationsGondola() {
		if (this.animationGondola1) this.animationGondola1.kill();
		if (this.animationGondola2) this.animationGondola2.kill();
		this.Gondola001.material.emissiveIntensity = 1;
		this.Gondola002.material.emissiveIntensity = 1;
	}
	stopAnimationsMostrador() {
		if (this.animationMostrador) this.animationMostrador.kill();
		this.Mostrador001.material.emissiveIntensity = 1;
	}

	onAnimationOpacity(object, callback = () => { }) {
		const newMaterial = object.material.clone();
		object.material = newMaterial;
		object.material.transparent = true
		gsap.to(object.material, {
			opacity: 0,
			duration: 2,
			onComplete: () => {
				callback()
			},
		});
	}

	onAnimate(object, intensity = 25) {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissiveIntensity = 1
			this.objectActiveAnimation = null
		}

		if (!object) {
			return
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		this.objectActiveAnimation = object
		// object.material.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: intensity,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	renderAnimations() { }
}
